import { useQueryClient, InfiniteData } from 'react-query';
import isEmpty from 'lodash/isEmpty';

import { Asset, PageSection, QUERY_KEYS } from '@24i/nxg-sdk-photon';

// Temporary solution to get the already fetched assets from the query cache
// TODO: This can be removed after -> PRDSAPPSTV-285 & PRDSAPPSTV-286
export const useFetchedAssets = (): Asset[] | undefined => {
    try {
        const queryClient = useQueryClient();
        const playlistQueries = queryClient.getQueriesData<InfiniteData<PageSection[]>>([
            QUERY_KEYS.playlists,
        ]);
        const playlistPages = playlistQueries.filter((playlist) => !isEmpty(playlist[1]));
        const { pages } = playlistPages[0][1];
        const rows = pages.reduce((acc, page) => acc.concat(page), []);
        const assets = rows.reduce(
            (acc, row) => (row.items ? acc?.concat(row.items) : acc),
            rows[0].items
        );
        return assets;
    } catch (error) {
        return undefined;
    }
};

// Temporary solution to get an already fetched asset from the query cache
// TODO: This can be removed after -> PRDSAPPSTV-285 & PRDSAPPSTV-286
export const useFetchedAsset = (id?: string): Asset | undefined => {
    try {
        const assets = useFetchedAssets();
        const asset = assets?.find((item) => item.id === id);
        return asset;
    } catch (error) {
        return undefined;
    }
};
